import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { getDefaultSaveSearchBean } from "@wikicasa/common/model/SaveSearchBean";
import axios from "axios";
import { handleAxiosError } from "./servicesUtils";
//@ts-ignore
var baseURL = window["_baseURLIt"];
var baseController = "".concat(baseURL, "/rest/publicUser");
export var getMenuInfo = () => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.get("".concat(baseController, "/getMenuInfo"));
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw null;
  }
});
export var getPublicUser = () => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.get("".concat(baseController, "/getUser"));
    return res.data;
  } catch (err) {
    handleAxiosError(err);
    throw null;
  }
});
export var getMarketingConsent = email => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.get("".concat(baseController, "/getMarketingConsent?email=").concat(email));
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    return false;
  }
});
export var deleteAllSaveSearch = () => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/deleteAllUserSaveSearch"));
    return res.data;
  } catch (err) {
    handleAxiosError(err);
    throw null;
  }
});
export var deleteSaveSearch = id => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/deleteUserSaveSearchParam/").concat(id));
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw null;
  }
});
export var deleteUser = () => __awaiter(void 0, void 0, void 0, function* () {
  try {
    yield axios.delete("".concat(baseController, "/deleteUser"));
    return true;
  } catch (error) {
    return false;
  }
});
export var getFavourites = () => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.get("".concat(baseController, "/getFavouriteIdList"));
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    return [];
  }
});
export var addUserFavorite = id => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/addUserFavourite/").concat(id));
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    return false;
  }
});
export var deleteUserFavorite = id => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/deleteUserFavourite/").concat(id));
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    return false;
  }
});
export var updateNote = (id, note) => __awaiter(void 0, void 0, void 0, function* () {
  if (note === " " || note === "  ") return false;
  try {
    var res = yield axios.post("".concat(baseController, "/updateFavouriteNote"), {
      realEstateId: id,
      note: note
    });
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    return false;
  }
});
export var removeFavourites = () => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/deleteAllUserFavourite"));
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    return false;
  }
});
export var saveUserFirebaseToken = firebaseToken => __awaiter(void 0, void 0, void 0, function* () {
  try {
    if (!firebaseToken) return false;
    yield axios.post("".concat(baseController, "/refreshUserFirebaseToken?token=").concat(firebaseToken));
    return true;
  } catch (err) {
    return false;
  }
});
export var deleteUserFirebaseToken = firebaseToken => __awaiter(void 0, void 0, void 0, function* () {
  try {
    yield axios.delete("".concat(baseController, "/deleteUserFirebaseToken?token=").concat(firebaseToken));
    return true;
  } catch (error) {
    return false;
  }
});
export var updateMarketingConsent = data => __awaiter(void 0, void 0, void 0, function* () {
  var {
    email,
    marketingConsent
  } = data;
  try {
    yield axios.post("".concat(baseController, "/updateMarketingConsent?email=").concat(email, "&marketingConsent=").concat(marketingConsent), data);
    return true;
  } catch (error) {
    handleAxiosError(error);
    return false;
  }
  /*    return $.ajax({
          type: "POST",
          contentType: "application/json",
          data: JSON.stringify(data),
          url: `/rest/publicUser/updateMarketingConsent?email=${email}&marketingConsent=${marketingConsent}`,
      });*/
});
export var getPublicUserSaveSearchList = function getPublicUserSaveSearchList() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  return __awaiter(void 0, void 0, void 0, function* () {
    try {
      var res = yield axios.get("".concat(baseController, "/getPublicUserSavedSearchBeanList/").concat(offset, "/").concat(limit));
      return res.data;
    } catch (error) {
      handleAxiosError(error);
      return [];
    }
  });
};
export var updatePublicUserSavedSearchBean = savedSearchBean => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/updatePublicUserSavedSearchBean/"), savedSearchBean);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    return getDefaultSaveSearchBean();
  }
});
export var getSavedSearchesCount = () => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.get("".concat(baseController, "/getPublicUserSaveSearchCount"));
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    return 0;
  }
});
export var updatePublicUserPassword = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/updateUserPassword"), data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});